export const businesses = {
  "demo-restaurant": {
    name: {
      en: "Demo Restaurant",
      ar: "مطعم تجريبي",
    },

    hero_subtitle: {
      en: "Fresh food, simple links, fast access.",
      ar: "طعام طازج وروابط سريعة وسهلة.",
    },

    background_color: "#0B0B0F",
    card_bg_color: "#FFFFFF",
    card_text_color: "#111111",
    button_bg_color: "#FFFFFF",
    button_text_color: "#111111",
    default_lang: "en",

    buttons: [
      {
        id: "menu",
        label: {
          en: "View Menu",
          ar: "عرض القائمة",
        },
        url: "https://example.com/menu",
        icon: "menu",
        enabled: true,
      },

      {
        id: "whatsapp",
        label: {
          en: "WhatsApp",
          ar: "واتساب",
        },
        url: "https://wa.me/971500000000",
        icon: "whatsapp",
        enabled: true,
      },

      {
        id: "instagram",
        label: {
          en: "Instagram",
          ar: "إنستغرام",
        },
        url: "https://instagram.com/",
        icon: "instagram",
        enabled: true,
      },

      {
        id: "location",
        label: {
          en: "Location",
          ar: "الموقع",
        },
        url: "https://maps.google.com/",
        icon: "map",
        enabled: true,
      },

      {
        id: "phone",
        label: {
          en: "Call Us",
          ar: "اتصل بنا",
        },
        url: "tel:+971500000000",
        icon: "phone",
        enabled: true,
      },
    ],
  },

  "strawberry-corner": {
    name: {
      en: "Strawberry Corner",
      ar: "ستروبيري كورنر",
    },

    hero_subtitle: {
      en: "Thank you for visiting us!🙏• We'd love to stay connected with you",
      ar: "شكرًا لزيارتكم لنا🙏• يسعدنا أن نبقى على تواصل معكم",
    },

    footer_text: {
      en: "We appreciate your support!",
      ar: "نقدّر دعمكم لنا!",
    },

    background_color: "#0B0206",
    card_bg_color: "#FFFFFF",
    card_text_color: "#111111",
    button_bg_color: "#FFFFFF",
    button_text_color: "#111111",
    default_lang: "en",

    buttons: [
      {
        id: "strawberry-review",
        label: {
          en: "Google Maps",
          ar: "خرائط جوجل",
        },
        subtitle: {
          en: "Rate us on ★★★★★",
          ar: "قيّمنا على ★★★★★",
        },
        url: "https://search.google.com/local/writereview?placeid=ChIJS2YqeOldXz4RCQZlN26tSSs",
        icon: "google",
        enabled: true,
        bg_color: "#E8B94F",
        text_color: "#111111",
      },

      {
        id: "strawberry-instagram",
        label: {
          en: "Instagram",
          ar: "إنستغرام",
        },
        subtitle: {
          en: "Follow us on",
          ar: "تابعنا على",
        },
        url: "https://www.instagram.com/strawberrycorner.ae?igsh=MTZtemltemkwczFzNg%3D%3D",
        icon: "instagram",
        enabled: true,
        bg_color: "#FF7A18",
        bg_gradient_end: "#9B2DE2",
        text_color: "#FFFFFF",
      },

      {
        id: "strawberry-tiktok",
        label: {
          en: "TikTok",
          ar: "تيك توك",
        },
        subtitle: {
          en: "Follow us on",
          ar: "تابعنا على",
        },
        url: "https://www.tiktok.com/@strawberry.corner?_r=1&_t=ZN-98PyVIIRfi2",
        icon: "tiktok",
        enabled: true,
        bg_color: "#101314",
        text_color: "#FFFFFF",
      },

      {
        id: "strawberry-facebook",
        label: {
          en: "Facebook",
          ar: "فيسبوك",
        },
        subtitle: {
          en: "Like us on",
          ar: "تابعنا على",
        },
        url: "https://www.facebook.com/strawberrycornerrigga",
        icon: "facebook",
        enabled: true,
        bg_color: "#2F80ED",
        text_color: "#FFFFFF",
      },

      {
        id: "strawberry-whatsapp",
        label: {
          en: "WhatsApp",
          ar: "واتساب",
        },
        subtitle: {
          en: "Chat with us on",
          ar: "تواصل معنا عبر",
        },
        url: "https://api.whatsapp.com/send/?phone=971558320330&text&type=phone_number&app_absent=0",
        icon: "whatsapp",
        enabled: true,
        bg_color: "#35C759",
        text_color: "#FFFFFF",
      },

      {
        id: "strawberry-location",
        label: {
          en: "Google Maps",
          ar: "الموقع",
        },
        subtitle: {
          en: "Find us on",
          ar: "اعثر علينا عبر",
        },
        url: "https://maps.app.goo.gl/p7fKENiwf5ttQL6Y6",
        icon: "map",
        enabled: true,
        bg_color: "#A8D8FF",
        bg_gradient_end: "#FFB6B6",
        text_color: "#111111",
      },

      {
        id: "strawberry-phone",
        label: {
          en: "Call Strawberry Corner",
          ar: "اتصل بستروبيري كورنر",
        },
        subtitle: {
          en: "Call us directly",
          ar: "اتصل بنا مباشرة",
        },
        url: "tel:+971558320330",
        icon: "phone",
        enabled: true,
        bg_color: "#F1F1F1",
        text_color: "#111111",
      },
    ],
  },

  "greenwich-gourmet": {
    name: {
      en: "Greenwich Gourmet",
      ar: "غرينتش غورميه",
    },

    hero_subtitle: {
      en: "Restaurant & Café",
      ar: "مطعم ومقهى",
    },

    footer_text: {
      en: "We appreciate your support!",
      ar: "نقدّر دعمكم لنا!",
    },

    background_color: "#071C16",
    card_bg_color: "#FFFFFF",
    card_text_color: "#111111",
    button_bg_color: "#FFFFFF",
    button_text_color: "#111111",
    default_lang: "en",

    buttons: [
      {
        id: "greenwich-review",
        label: {
          en: "Google Review",
          ar: "تقييم جوجل",
        },
        subtitle: {
          en: "Rate us on",
          ar: "قيّمنا على",
        },
        url: "https://search.google.com/local/writereview?placeid=ChIJSTMWiWJDXz4RQmhhAPME97E",
        icon: "google",
        enabled: true,
        bg_color: "#E8B94F",
        text_color: "#111111",
      },

      {
        id: "greenwich-instagram",
        label: {
          en: "Instagram",
          ar: "إنستغرام",
        },
        subtitle: {
          en: "Follow us on",
          ar: "تابعنا على",
        },
        url: "https://www.instagram.com/greenwichgourmetrestaurantcafe?igsh=MWJ5aXAwbmk4dzgyZw==",
        icon: "instagram",
        enabled: true,
        bg_color: "#FF7A18",
        bg_gradient_end: "#9B2DE2",
        text_color: "#FFFFFF",
      },

      {
        id: "greenwich-tiktok",
        label: {
          en: "TikTok",
          ar: "تيك توك",
        },
        subtitle: {
          en: "Follow us on",
          ar: "تابعنا على",
        },
        url: "https://www.tiktok.com/@greenwichgourmet?_r=1&_t=ZN-98Q0cQFhgIw",
        icon: "tiktok",
        enabled: true,
        bg_color: "#101314",
        text_color: "#FFFFFF",
      },

      {
        id: "greenwich-phone",
        label: {
          en: "Call Greenwich Gourmet",
          ar: "اتصل بغرينتش غورميه",
        },
        subtitle: {
          en: "Call us directly",
          ar: "اتصل بنا مباشرة",
        },
        url: "tel:+97142992242",
        icon: "phone",
        enabled: true,
        bg_color: "#FFFFFF",
        text_color: "#111111",
      },
    ],
  },
};
